export { default } from './CDCProtegido25AvisarSinistro';
